import { Product } from "@/types/models/product";
import { ProductFilters, productService } from "@/services/productService";
import { createCrudSagas } from "@/utils/createCrudSagas";
import { productSlice } from "@/store/slices/productNew.slice";

// Create the product sagas using the generic CRUD pattern
export const productSagas = createCrudSagas<Product, ProductFilters>({
  service: productService,
  actions: productSlice.actions,
  entityName: "product",
});

// Export the root saga
export default productSagas.rootSaga;
